var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
export var InfoIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props, { role: "button" }),
    React.createElement("path", { fill: "currentColor", d: "M12 22.8C17.9647 22.8 22.8 17.9647 22.8 12C22.8 6.03532 17.9647 1.2 12 1.2C6.03532 1.2 1.2 6.03532 1.2 12C1.2 17.9647 6.03532 22.8 12 22.8ZM12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM12 9.6C12.3314 9.6 12.6 9.86863 12.6 10.2V18.6C12.6 18.9314 12.3314 19.2 12 19.2C11.6686 19.2 11.4 18.9314 11.4 18.6V10.2C11.4 9.86863 11.6686 9.6 12 9.6ZM12 4.8C12.6627 4.8 13.2 5.33726 13.2 6C13.2 6.66274 12.6627 7.2 12 7.2C11.3373 7.2 10.8 6.66274 10.8 6C10.8 5.33726 11.3373 4.8 12 4.8Z" }))); };
//# sourceMappingURL=InfoIcon.js.map